import React, { useEffect } from 'react';
import AppRoutes from './AppRoutes';
import { config } from './config/env';

const App: React.FC = () => {
  useEffect(() => {
    document.title = config.appName;
  }, []);

  return <AppRoutes />;
};

export default App;
